import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Configurar interceptor de axios para agregar token
    const interceptor = axios.interceptors.request.use(
      (config) => {
        const storedToken = localStorage.getItem('token');
        if (storedToken) {
          config.headers.Authorization = `Bearer ${storedToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Verificar token al cargar
    if (token) {
      verificarToken();
    } else {
      setLoading(false);
    }

    return () => {
      axios.interceptors.request.eject(interceptor);
    };
  }, []);

  const verificarToken = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsuario(response.data);
      setIsAuthenticated(true);
    } catch (error) {
      // Token inválido o expirado
      localStorage.removeItem('token');
      setToken(null);
      setUsuario(null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, { email, password });
      const { access_token, usuario: userData } = response.data;
      
      localStorage.setItem('token', access_token);
      sessionStorage.setItem('forzar_propiedad_default', 'true');
      setToken(access_token);
      setUsuario(userData);
      setIsAuthenticated(true);
      
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.detail || 'Error al iniciar sesión';
      return { success: false, error: message };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('forzar_propiedad_default');
    setToken(null);
    setUsuario(null);
    setIsAuthenticated(false);
  };

  const isAdmin = () => {
    return usuario?.is_admin === true;
  };

  const getPropiedadesAsignadas = () => {
    return usuario?.propiedades_asignadas || [];
  };

  return (
    <AuthContext.Provider
      value={{
        usuario,
        token,
        loading,
        isAuthenticated,
        login,
        logout,
        isAdmin,
        getPropiedadesAsignadas,
        verificarToken
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de AuthProvider');
  }
  return context;
};
